import React, { useEffect, useState } from 'react'
import { Machine } from 'common/types/Machine'
import { useServerConnection } from '../hooks/ServerConnection'
import { useGitlabAccessToken } from '../hooks/GitlabAccessToken'
import { useTimeDifference } from '../hooks/TimeDifference'
import { Button } from 'semantic-ui-react'

const AutoSuspendControls = ({ machine }: { machine: Machine }) => {
    const [accessToken] = useGitlabAccessToken()
    const serverConnection = useServerConnection()
    const serverTimeDiff = useTimeDifference()

    const [showControls, setShowControls] = useState(false)

    const [now, setNow] = useState(Date.now() - serverTimeDiff)

    useEffect(() => {
        const interval = setInterval(() => {
            if(serverTimeDiff) {
                setNow(Date.now() - serverTimeDiff)
            }
        }, 1000)
    
        return () => {
            clearInterval(interval)
        }
    }, [serverTimeDiff])

    const { temporaryDisableAutoSuspend } = machine

    if(now === null) {
        return <div/>
    }

    if(temporaryDisableAutoSuspend.type === "no" || (
        temporaryDisableAutoSuspend.type === "yes"
        && temporaryDisableAutoSuspend.until < now
    )) {
        return (
            <div style={{
                borderTop: "1px solid #e3e3e3",
                borderBottom: "1px solid #e3e3e3",
                marginTop: 5,
                paddingTop: 5,
                paddingBottom: 5,
            }}>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                }}>
                    <div style={{
                        whiteSpace: "nowrap"
                    }}>
                        Auto Suspend:
                    </div>
                    <div style={{
                        marginLeft: 5,
                    }}>
                        On
                    </div>
                    <Button
                        style={{
                            marginLeft: 5,
                            fontSize: "11px",
                        }}
                        size='small'
                        icon="setting"
                        onClick={() => setShowControls(!showControls)}
                    />
                </div>
                {
                    showControls && (
                        <div style={{
                            marginTop: 5,
                            display: "flex",
                            alignItems: "center",
                        }}>
                            <div style={{
                                whiteSpace: "nowrap",
                            }}>
                                Disable for:
                            </div>
                            {
                                [
                                    "1h" as const,
                                    "3h" as const,
                                    "6h" as const,
                                    "12h" as const,
                                ].map((delay) => {
                                    return (
                                        <button
                                            key={delay}
                                            style={{
                                                marginLeft: 10,
                                                padding: 5,
                                                whiteSpace: "nowrap",
                                                background: "#e3e3e3",
                                                borderRadius: 4,
                                            }}
                                            onClick={() => serverConnection.disableAutoSuspendFor(accessToken, machine._id, delay)}
                                        >
                                            {delay}
                                        </button>
                                    )
                                })
                            }
                        </div>
                    )
                }
            </div>
        )
    } else if(temporaryDisableAutoSuspend.type === "yes") {
        const timeLeft = temporaryDisableAutoSuspend.until - now
        const minutesLeft = Math.ceil((((timeLeft) / 1000) - 1) / 60)

        return (
            <div style={{
                borderTop: "1px solid #e3e3e3",
                borderBottom: "1px solid #e3e3e3",
                marginTop: 5,
                paddingTop: 5,
                paddingBottom: 5,
            }}>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                }}>
                    <div style={{
                        whiteSpace: "nowrap",
                    }}>
                        Auto Suspend:
                    </div>
                    <div style={{
                        marginLeft: 5,
                        whiteSpace: "nowrap",
                    }}>
                        Off for {minutesLeft} {minutesLeft.toString().slice(-1)[0] === "1" ? "minute" : "minutes"}
                    </div>
                    <Button
                        style={{
                            marginLeft: 5,
                            fontSize: "11px",
                        }}
                        size='small'
                        icon="setting"
                        onClick={() => setShowControls(!showControls)}
                    />
                </div>
                {
                    showControls && (
                        <>                        
                            <button
                                style={{
                                    marginTop: 5,
                                    padding: 5,
                                    whiteSpace: "nowrap",
                                    background: "#e3e3e3",
                                    borderRadius: 4,
                                }}
                                onClick={() => serverConnection.enableAutoSuspend(accessToken, machine._id)}
                            >
                                Enable
                            </button>
                            <div style={{
                                marginTop: 5,
                                display: "flex",
                                alignItems: "center",
                            }}>
                                <div style={{
                                    whiteSpace: "nowrap",
                                }}>
                                    Disable for:
                                </div>
                                {
                                    [
                                        "1h" as const,
                                        "3h" as const,
                                        "6h" as const,
                                        "12h" as const,
                                    ].map((delay) => {
                                        return (
                                            <button
                                                key={delay}
                                                style={{
                                                    marginLeft: 10,
                                                    padding: 5,
                                                    whiteSpace: "nowrap",
                                                    background: "#e3e3e3",
                                                    borderRadius: 4,
                                                }}
                                                onClick={() => serverConnection.disableAutoSuspendFor(accessToken, machine._id, delay)}
                                            >
                                                {delay}
                                            </button>
                                        )
                                    })
                                }
                            </div>
                        </>
                    )
                }
            </div>
        )
    }
}



export default AutoSuspendControls